import AddressAutocomplete from './AddressAutocomplete';

export default AddressAutocomplete;
